import { render, staticRenderFns } from "./SpecialOrders.vue?vue&type=template&id=874bc892&scoped=true&"
import script from "./SpecialOrders.vue?vue&type=script&lang=js&"
export * from "./SpecialOrders.vue?vue&type=script&lang=js&"
import style0 from "./SpecialOrders.vue?vue&type=style&index=0&id=874bc892&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874bc892",
  null
  
)

export default component.exports